export const NA_TIMEZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Phoenix',
  'America/Anchorage',
  'America/Juneau',
  'America/Adak',
  'Pacific/Honolulu'
]

export const zoneAbbrs: { [key: string]: string[] } = {
  'America/New_York': ['EST', 'EDT'],
  'America/Chicago': ['CST', 'CDT'],
  'America/Denver': ['MST', 'MDT'],
  'America/Los_Angeles': ['PST', 'PDT'],
  'America/Phoenix': ['MST', 'MST'], // No DST
  'America/Anchorage': ['AKST', 'AKDT'],
  'America/Juneau': ['AKST', 'AKDT'],
  'America/Adak': ['HST', 'HDT'],
  'Pacific/Honolulu': ['HST', 'HST'] // No DST
}

export const DATE_STRING = 'YYYY-MM-DD HH:mm:ss'

/** Frontend uses Pacific; backend stores UTC. Use for all date display and form parsing. */
export const PACIFIC_TIMEZONE = 'America/Los_Angeles'

export const OUTDATED_CREATIVE_WARNING =
  'This flight includes creative assets that will not be delivered. Please edit the flight to add targeting for the unused formats. Failure to update targeting will result in some assets not playing.'

export const MISSING_CREATIVE_WARNING =
  'This flight requires additional creative formats to deliver as planned. Please upload the remaining formats, or edit the flight to remove the unused formats. Failure to provide all creative formats may result in under-delivery.'

export const CREATIVE_TIMEFRAME_WARNING =
  // eslint-disable-next-line quotes
  "Some creatives are outside of the flight's timeframe. Creatives will play within the flight's timeframe."

export const TARGETING_UNINSTALLED_STORES_WARNING =
  'These stores were previously targeted but are no longer installed and will not appear in the targeting list.'

// Auth/Login status codes
export const AUTH_STATUS = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  MFA_STATUS_ENROLLED: 'MFA_STATUS_ENROLLED'
} as const

export const US_STATES = {
  AL: 'Alabama',
  AK: 'Alaska' ,
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Islands',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
}
